import React from 'react';
import GenericModal from 'Components/GenericModal';
import PciResponsabilityModal from 'Components/PciResponsabilityModal';
import ProtectionPlusModal from 'Components/ProtectionPlusModal';
import CreateSafePasswordModal from 'Components/CreateSafePasswordModal';
import LegalRepPEPModal from 'Components/LegalRepPEPModal';
import PciNeedHelpModal from 'Components/PciNeedHelpModal';
import BlockedModal from 'Components/BlockedModal';
import VetrinaDigitaleSubmitPopup from 'Components/VetrinaDigitaleSubmitPopup';
import RegAttemptsExceededModal from 'Route/Registration/components/RegAttemptsExceededModal';
import BackbookUserNotRegisteredModal from 'Route/RecoveryPassword/components/BackbookUserNotRegisteredModal';
import RecoveryAttemptsExceededModal from 'Route/RecoveryPassword/components/RecoveryAttemptsExceededModal';
import GoToNpgSsoModal from 'Route/MobileSso/components/GoToNpgSsoModal';
import GoToWcfSsoModal from 'Route/MobileSso/components/GoToWcfSsoModal';
import TechnicalErrorModal from '../components/TechnicalErrorModal';
import CallUsModal from 'Route/CallUs/components/CallUsModal';
import InformativeISPModal from 'Route/PersonalData/components/InformativeIspModal';
import PayByLinkTutorialPopup from 'Components/PayByLinkTutorialPopup';
import PayByLinkFirstActivationPopup from 'Components/PayByLinkFirstActivationPopup';
import BiometricDialog from 'Components/BiometricDialog';
import ChooseFileDialog from 'Components/ChooseFileDialog';
import PrivacyConsentsModal from 'Route/PersonalData/components/PrivacyConsentsModal';
import HeyLightPopup from 'Components/HeyLightPopup';
import EditCompanyPopup from 'Components/EditCompanyPopup';
import DeleteCartItemModal from 'Components/DeleteCartItemModal';
import PayByLinkFilterModal from 'Components/PayByLinkFilterModal';
import ModifyNumberModal from 'Components/ModifyNumberModal';
import DocumentsStatementsCustomDownloadModal from 'Components/DocumentsStatementsCustomDownloadModal';
import XpayBackOfficePopup from 'Components/XpayBackOfficePopup';
import CommerceWebTenantPopup from 'Components/CommerceWebTenantPopup';
import SettingsLanguagePopup from 'Components/SettingsLanguagePopup';
import SettingsAlertPopup from 'Components/SettingsAlertPopup';
import SettingsBankStatementPopup from 'Components/SettingsBankStatementPopup';
import ShopPickerPopup from 'Components/ShopPickerPopup';
import GenericShopList from 'Components/GenericShopList';
import MerchantPayByLinkDetail from 'Route/PayByLink/components/MerchantPayByLinkDetail';
import TransactionDetailsNotePopup from 'Components/TransactionDetailsNotePopup';
import TransactionReversePopup from 'Components/TransactionReversePopup';
import TransactionsDownloadAllPopup from 'Components/TransactionsDownloadAllPopup';
import ConfirmReverseTransactionModal from 'Components/ConfirmReverseTransactionModal';
import CheckRefundableTransactionModal from 'Components/CheckRefundableTransactionModal';
import NexiClubWaiverPopup from 'Components/NexiClubWaiverPopup';
import AmlPopup from 'Route/TriggerTimeline/components/AmlPopup';
import OtpPopup from 'Components/OtpPopup';
import AmlPopupConfirm from 'Components/AmlPopupConfirm';
import CostsCustomDownloadModal from 'Components/CostsCustomDownloadModal';
import CostsDebitDetailsDownloadModal from 'Components/CostsDebitDetailsDownloadModal';
import PaymentsDetail from 'Route/Results/components/PaymentsDetail';
import ClientsDetail from 'Route/Results/components/ClientsDetail';
import ForeignCardDetail from 'Route/Results/components/ForeignCardDetail';
import RubiconePopup from 'Components/RubiconePopup';
import RubiconePromoCarouselPopup from 'Components/RubiconePromoCarouselPopup';
import ProtectClientDataModal from 'Components/ProtectClientDataModal';
import VerifyPOSModal from 'Components/VerifyPOSModal';
import ChooseSuppliersModal from 'Components/ChooseSuppliersModal';
import ControlAccessModal from 'Components/ControlAccessModal';
import PreventAttacksModal from 'Components/PreventAttacksModal';
import UseAntivirusSoftware from 'Components/UseAntivirusSoftware';
import ProtectNetworksModal from 'Components/ProtectNetworksModal';
import PerformRegularSecurityTests from 'Components/PerformRegularSecurityTests';
import PciEmailDocumentsModal from 'Components/PciEmailDocumentsModal';
import ChargebackDownloadPopup from 'Components/ChargebackDownloadPopup';
import ExtendSessionModal from 'Components/ExtendSessionModal';
import ExpiredSessionModal from 'Components/ExpiredSessionModal';
import EconomicConditionsSelectorModal from 'Components/EconomicConditionsSelectorModal';
import CostsShopPickerPopup from 'Components/CostsShopPickerPopup';
import SecondaryUserShopListModal from 'Components/SecondaryUserShopListModal';
import DisputeShopPickerPopup from 'Components/DisputeShopPickerPopup';
import GoToOldNpgModal from 'Route/OldNpg/components/GoToOldNpgModal'
import DisputeFilterModal from 'Route/DisputeUci/components/DisputeFilterModal';
import DisputeEntryModal from 'Route/DisputeUci/components/DisputeEntryModal';
import DisputeDownloadModal from 'Route/DisputeUci/components/DisputeDownloadModal';
import DisputeUciTimeoutModal from 'Route/DisputeUci/components/DisputeUciTimeoutModal';
import PagoPaDownloadAllPopup from 'Components/PagoPaDownloadAllPopup';

export const flowPopupMapType = {
  GENERIC_POPUP: 'GENERIC_POPUP',
  PCI_RESPONSABILITY_MODAL: 'PCI_RESPONSABILITY_MODAL',
  PROTECTION_PLUS_MODAL: 'PROTECTION_PLUS_MODAL',
  PCI_CREATE_SAFE_PASSWORD_MODAL: 'PCI_CREATE_SAFE_PASSWORD_MODAL',
  PCI_PROTECT_CLIENT_DATA_MODAL: 'PCI_PROTECT_CLIENT_DATA_MODAL',
  PCI_CHOOSE_SUPPLIER_MODAL: 'PCI_CHOOSE_SUPPLIER_MODAL',
  PCI_VERIFY_POS_MODAL: 'PCI_VERIFY_POS_MODAL',
  PCI_CONTROL_ACCESS_MODAL: 'PCI_CONTROL_ACCESS_MODAL',
  PCI_PREVENT_ATTACKS_MODAL: 'PCI_PREVENT_ATTACKS_MODAL',
  PCI_USE_ANTIVIRUS_SOFTWARE_MODAL: 'PCI_USE_ANTIVIRUS_SOFTWARE_MODAL',
  PCI_PROTECT_NETWORKS_MODAL: 'PCI_PROTECT_NETWORKS_MODAL',
  PCI_SECURITY_TEST_MODAL: 'PCI_SECURITY_TEST_MODAL',
  PCI_EMAIL_DOCUMENTS_MODAL: 'PCI_EMAIL_DOCUMENTS_MODAL',
  LEGALREP_PEP_POPUP: 'LEGALREP_PEP_POPUP',
  PCI_NEED_HELP_POPUP: 'PCI_NEED_HELP_POPUP',
  BLOCKED_USER_SUSPEND: 'BLOCKED_USER_SUSPEND',
  BLOCKED_USER_REVOKE: 'BLOCKED_USER_REVOKE',
  BLOCKED_24H_MODAL: 'BLOCKED_24H_MODAL',
  BLOCKED_MFA_MODAL: 'BLOCKED_MFA_MODAL',
  BLOCKED_USER: 'BLOCKED_USER',
  BLOCKED_OFFLINE_APP: 'BLOCKED_OFFLINE_APP',
  BLOCKED_MUST_UPDATE_APP: 'BLOCKED_MUST_UPDATE_APP',
  USER_NOT_VALID: 'USER_NOT_VALID',
  SERVICE_NOT_AVAILABLE: 'SERVICE_NOT_AVAILABLE',
  SERVICE_NOT_AVAILABLE_REFRESH: 'SERVICE_NOT_AVAILABLE_REFRESH',
  REG_ACCOUNT_DISABLED: 'REG_ACCOUNT_DISABLED',
  REG_ATTEMPTS_EXCEEDED_POPUP: 'REG_ATTEMPTS_EXCEEDED_POPUP',
  REG_VAT_EMAIL_APPEMPTS_ERROR_MODAL: 'REG_VAT_EMAIL_APPEMPTS_ERROR_MODAL',
  RECOVERY_BACKBOOK_USER_NOT_REGISTERED: 'RECOVERY_BACKBOOK_USER_NOT_REGISTERED',
  RECOVERY_ATTEMPTS_EXCEEDED_POPUP: 'RECOVERY_ATTEMPTS_EXCEEDED_POPUP',
  TECHNICAL_ERROR_MODAL: 'TECHNICAL_ERROR_MODAL',
  CALL_US: 'CALL_US',
  VETRINA_DIGITALE_NEW_SUBMIT: 'VETRINA_DIGITALE_NEW_SUBMIT',
  VETRINA_DIGITALE_NEW_SUBMIT_FAILED: 'VETRINA_DIGITALE_NEW_SUBMIT_FAILED',
  INFORMATIVE_ISP_MODAL: 'INFORMATIVE_ISP_MODAL',
  PAY_BY_LINK_TUTORIAL: 'PAY_BY_LINK_TUTORIAL',
  PAY_BY_LINK_FIRST_ACTIVATION: 'PAY_BY_LINK_FIRST_ACTIVATION',
  PAY_BY_LINK_FILTER: 'PAY_BY_LINK_FILTER',
  PAY_BY_LINK_DETAIL: 'PAY_BY_LINK_DETAIL',
  ASK_BIOMETRIC: 'ASK_BIOMETRIC',
  CHOOSE_FILE: 'CHOOSE_FILE',
  HEYLIGHT_POPUP: 'HEYLIGHT_POPUP',
  PRIVACY: 'PRIVACY',
  EDIT_COMPANY_DATA: 'EDIT_COMPANY_DATA',
  DELETE_ITEM_CART_MODAL: 'DELETE_ITEM_CART_MODAL',
  MODIFY_NUMBER_MODAL: 'MODIFY_NUMBER_MODAL',
  DOCUMENTS_STATEMENTS_CUSTOM_DOWNLOAD: 'DOCUMENTS_STATEMENTS_CUSTOM_DOWNLOAD',
  XPAY_BACKOFFICE_POPUP: 'XPAY_BACKOFFICE_POPUP',
  COMMERCE_WEB_TENANT_POPUP: 'COMMERCE_WEB_TENANT_POPUP',
  XPAY_EASY_POPUP: 'XPAY_EASY_POPUP',
  SETTINGS_LANGUAGE_POPUP: 'SETTINGS_LANGUAGE_POPUP',
  SETTINGS_ALERT_POPUP: 'SETTINGS_ALERT_POPUP',
  SETTINGS_BANK_STATEMENT_POPUP: 'SETTINGS_BANK_STATEMENT_POPUP',
  SHOP_PICKER: 'SHOP_PICKER',
  GENERIC_SHOP_LIST: 'GENERIC_SHOP_LIST',
  TRANSACTION_DETAILS_NOTE_POPUP: 'TRANSACTION_DETAILS_NOTE_POPUP',
  TRANSACTION_REVERSE_POPUP: 'TRANSACTION_REVERSE_POPUP',
  TRANSACTIONS_DOWNLOAD_ALL_POPUP: 'TRANSACTIONS_DOWNLOAD_ALL_POPUP',
  CONFIRM_REFUND_TRANSACTION_MODAL: 'CONFIRM_REFUND_TRANSACTION_MODAL',
  CHECK_REFUNDABLE_TRANSACTION_MODAL: 'CHECK_REFUNDABLE_TRANSACTION_MODAL',
  NEXI_CLUB_WAIVER_POPUP: 'NEXI_CLUB_WAIVER_POPUP',
  GO_TO_NPG_SSO_MODAL: 'GO_TO_NPG_SSO_MODAL',
  GO_TO_WCF_SSO_MODAL: 'GO_TO_WCF_SSO_MODAL',
  GO_TO_OLD_NPG_MODAL: 'GO_TO_OLD_NPG_MODAL',
  AML_MODAL: 'AML_MODAL',
  OTP_MODAL: 'OTP_MODAL',
  COSTS_CUSTOM_DOWNLOAD_MODAL: 'COSTS_CUSTOM_DOWNLOAD_MODAL',
  COSTS_DEBIT_DETAILS_DOWNLOAD_MODAL: 'COSTS_DEBIT_DETAILS_DOWNLOAD_MODAL',
  AML_MODAL_CONFIRM: 'AML_MODAL_CONFIRM',
  RUBICONE_POPUP: 'RUBICONE_POPUP',
  RESULTS_PAYMENTS_DETAIL: 'RESULTS_PAYMENTS_DETAIL',
  RESULTS_CLIENTS_DETAIL: 'RESULTS_CLIENTS_DETAIL',
  RESULTS_CARDS_DETAIL: 'RESULTS_CARDS_DETAIL',
  RUBICONE_PROMO_CAROUSEL_POPUP: 'RUBICONE_PROMO_CAROUSEL_POPUP',
  CHARGEBACK_DOWNLOAD_POPUP: 'CHARGEBACK_DOWNLOAD_POPUP',
  EXTEND_SESSION: 'EXTEND_SESSION',
  EXPIRED_SESSION: 'EXPIRED_SESSION',
  BLOCKED_ROOTED_APP: 'BLOCKED_ROOTED_APP',
  BLOCKED_SSL_INVALID_APP: 'BLOCKED_SSL_INVALID_APP',
  ECONOMIC_CONDITIONS_SELECTOR_MODAL: 'ECONOMIC_CONDITIONS_SELECTOR_MODAL',
  COSTS_SHOP_PICKER: 'COSTS_SHOP_PICKER',
  SECONDARY_USER_SHOP_LIST_MODAL: 'SECONDARY_USER_SHOP_LIST_MODAL',
  DISPUTE_FILTER_MODAL: 'DISPUTE_FILTER_MODAL',
  DISPUTE_ENTRY_MODAL: 'DISPUTE_ENTRY_MODAL',
  DISPUTE_SHOP_PICKER: 'DISPUTE_SHOP_PICKER',
  DISPUTE_DOWNLOAD_MODAL: 'DISPUTE_DOWNLOAD_MODAL',
  DISPUTE_UCI_TIMEOUT_MODAL: 'DISPUTE_UCI_TIMEOUT_MODAL',
  PAGOPA_DOWNLOAD_ALL_POPUP: 'PAGOPA_DOWNLOAD_ALL_POPUP'
};

export const flowPopupMap = {
  [flowPopupMapType.GENERIC_POPUP]: <GenericModal />,
  [flowPopupMapType.DISPUTE_FILTER_MODAL]: <DisputeFilterModal />,
  [flowPopupMapType.DISPUTE_ENTRY_MODAL]: <DisputeEntryModal />,
  [flowPopupMapType.DISPUTE_DOWNLOAD_MODAL]: <DisputeDownloadModal />,
  [flowPopupMapType.DISPUTE_UCI_TIMEOUT_MODAL]: <DisputeUciTimeoutModal />,
  [flowPopupMapType.PCI_RESPONSABILITY_MODAL]: <PciResponsabilityModal />,
  [flowPopupMapType.PCI_CREATE_SAFE_PASSWORD_MODAL]: <CreateSafePasswordModal />,
  [flowPopupMapType.PCI_PROTECT_CLIENT_DATA_MODAL]: <ProtectClientDataModal />,
  [flowPopupMapType.PCI_VERIFY_POS_MODAL]: <VerifyPOSModal />,
  [flowPopupMapType.PCI_CHOOSE_SUPPLIER_MODAL]: <ChooseSuppliersModal />,
  [flowPopupMapType.PCI_CONTROL_ACCESS_MODAL]: <ControlAccessModal />,
  [flowPopupMapType.PCI_PREVENT_ATTACKS_MODAL]: <PreventAttacksModal />,
  [flowPopupMapType.PCI_USE_ANTIVIRUS_SOFTWARE_MODAL]: <UseAntivirusSoftware />,
  [flowPopupMapType.PCI_PROTECT_NETWORKS_MODAL]: <ProtectNetworksModal />,
  [flowPopupMapType.PCI_SECURITY_TEST_MODAL]: <PerformRegularSecurityTests />,
  [flowPopupMapType.PCI_EMAIL_DOCUMENTS_MODAL]: <PciEmailDocumentsModal />,
  [flowPopupMapType.PROTECTION_PLUS_MODAL]: <ProtectionPlusModal />,
  [flowPopupMapType.LEGALREP_PEP_POPUP]: <LegalRepPEPModal />,
  [flowPopupMapType.PCI_NEED_HELP_POPUP]: <PciNeedHelpModal />,
  [flowPopupMapType.BLOCKED_24H_MODAL]: <BlockedModal type='BLOCKED_24H_MODAL' />,
  [flowPopupMapType.BLOCKED_MFA_MODAL]: <BlockedModal type='BLOCKED_MFA_MODAL' />,
  [flowPopupMapType.BLOCKED_USER]: <BlockedModal type='BLOCKED_USER' />,
  [flowPopupMapType.USER_NOT_VALID]: <BlockedModal type='USER_NOT_VALID' />,
  [flowPopupMapType.SERVICE_NOT_AVAILABLE]: <BlockedModal type='SERVICE_NOT_AVAILABLE' />,
  [flowPopupMapType.SERVICE_NOT_AVAILABLE_REFRESH]: <BlockedModal type='SERVICE_NOT_AVAILABLE' refreshLogin />,
  [flowPopupMapType.BLOCKED_USER_SUSPEND]: <BlockedModal type='BLOCKED_USER_SUSPEND' />,
  [flowPopupMapType.BLOCKED_USER_REVOKE]: <BlockedModal type='BLOCKED_USER_REVOKE' />,
  [flowPopupMapType.REG_ACCOUNT_DISABLED]: <BlockedModal type='REG_ACCOUNT_DISABLED' />,
  [flowPopupMapType.BLOCKED_OFFLINE_APP]: <BlockedModal type='BLOCKED_OFFLINE_APP' />,
  [flowPopupMapType.BLOCKED_MUST_UPDATE_APP]: <BlockedModal type='BLOCKED_MUST_UPDATE_APP' />,
  [flowPopupMapType.BLOCKED_ROOTED_APP]: <BlockedModal type='BLOCKED_ROOTED_APP' />,
  [flowPopupMapType.BLOCKED_SSL_INVALID_APP]: <BlockedModal type='BLOCKED_SSL_INVALID_APP' />,
  [flowPopupMapType.REG_ATTEMPTS_EXCEEDED_POPUP]: <RegAttemptsExceededModal />,
  [flowPopupMapType.REG_VAT_EMAIL_APPEMPTS_ERROR_MODAL]: <BlockedModal type='REG_VAT_EMAIL_APPEMPTS_ERROR_MODAL' />,
  [flowPopupMapType.RECOVERY_BACKBOOK_USER_NOT_REGISTERED]: <BackbookUserNotRegisteredModal />,
  [flowPopupMapType.RECOVERY_ATTEMPTS_EXCEEDED_POPUP]: <RecoveryAttemptsExceededModal />,
  [flowPopupMapType.TECHNICAL_ERROR_MODAL]: <TechnicalErrorModal />,
  [flowPopupMapType.CALL_US]: <CallUsModal />,
  [flowPopupMapType.VETRINA_DIGITALE_NEW_SUBMIT]: <VetrinaDigitaleSubmitPopup />,
  [flowPopupMapType.VETRINA_DIGITALE_NEW_SUBMIT_FAILED]: <TechnicalErrorModal />,
  [flowPopupMapType.INFORMATIVE_ISP_MODAL]: <InformativeISPModal />,
  [flowPopupMapType.PAY_BY_LINK_TUTORIAL]: <PayByLinkTutorialPopup />,
  [flowPopupMapType.PAY_BY_LINK_FIRST_ACTIVATION]: <PayByLinkFirstActivationPopup />,
  [flowPopupMapType.ASK_BIOMETRIC]: <BiometricDialog />,
  [flowPopupMapType.CHOOSE_FILE]: <ChooseFileDialog />,
  [flowPopupMapType.HEYLIGHT_POPUP]: <HeyLightPopup />,
  [flowPopupMapType.PRIVACY]: <PrivacyConsentsModal />,
  [flowPopupMapType.EDIT_COMPANY_DATA]: <EditCompanyPopup />,
  [flowPopupMapType.DELETE_ITEM_CART_MODAL]: <DeleteCartItemModal />,
  [flowPopupMapType.PAY_BY_LINK_FILTER]: <PayByLinkFilterModal />,
  [flowPopupMapType.PAY_BY_LINK_DETAIL]: <MerchantPayByLinkDetail />,
  [flowPopupMapType.MODIFY_NUMBER_MODAL]: <ModifyNumberModal />,
  [flowPopupMapType.DOCUMENTS_STATEMENTS_CUSTOM_DOWNLOAD]: <DocumentsStatementsCustomDownloadModal />,
  [flowPopupMapType.XPAY_BACKOFFICE_POPUP]: <XpayBackOfficePopup />,
  [flowPopupMapType.COMMERCE_WEB_TENANT_POPUP]: <CommerceWebTenantPopup />,
  [flowPopupMapType.SETTINGS_LANGUAGE_POPUP]: <SettingsLanguagePopup />,
  [flowPopupMapType.SETTINGS_ALERT_POPUP]: <SettingsAlertPopup />,
  [flowPopupMapType.SETTINGS_BANK_STATEMENT_POPUP]: <SettingsBankStatementPopup />,
  [flowPopupMapType.SHOP_PICKER]: <ShopPickerPopup open={true} />,
  [flowPopupMapType.COSTS_SHOP_PICKER]: <CostsShopPickerPopup open={true} />,
  [flowPopupMapType.DISPUTE_SHOP_PICKER]: <DisputeShopPickerPopup open={true} />,
  [flowPopupMapType.GENERIC_SHOP_LIST]: <GenericShopList open={true} />,
  [flowPopupMapType.TRANSACTION_DETAILS_NOTE_POPUP]: <TransactionDetailsNotePopup />,
  [flowPopupMapType.TRANSACTION_REVERSE_POPUP]: <TransactionReversePopup />,
  [flowPopupMapType.TRANSACTIONS_DOWNLOAD_ALL_POPUP]: <TransactionsDownloadAllPopup />,
  [flowPopupMapType.CONFIRM_REFUND_TRANSACTION_MODAL]: <ConfirmReverseTransactionModal />,
  [flowPopupMapType.CHECK_REFUNDABLE_TRANSACTION_MODAL]: <CheckRefundableTransactionModal />,
  [flowPopupMapType.NEXI_CLUB_WAIVER_POPUP]: <NexiClubWaiverPopup />,
  [flowPopupMapType.GO_TO_NPG_SSO_MODAL]: <GoToNpgSsoModal />,
  [flowPopupMapType.GO_TO_WCF_SSO_MODAL]: <GoToWcfSsoModal />,
  [flowPopupMapType.AML_MODAL]: <AmlPopup fromTTL={false} />,
  [flowPopupMapType.AML_MODAL_CONFIRM]: <AmlPopupConfirm />,
  [flowPopupMapType.OTP_MODAL]: <OtpPopup />,
  [flowPopupMapType.COSTS_CUSTOM_DOWNLOAD_MODAL]: <CostsCustomDownloadModal />,
  [flowPopupMapType.COSTS_DEBIT_DETAILS_DOWNLOAD_MODAL]: <CostsDebitDetailsDownloadModal />,
  [flowPopupMapType.RUBICONE_POPUP]: <RubiconePopup />,
  [flowPopupMapType.RESULTS_PAYMENTS_DETAIL]: <PaymentsDetail open={true} />,
  [flowPopupMapType.RESULTS_CLIENTS_DETAIL]: <ClientsDetail open={true} />,
  [flowPopupMapType.RESULTS_CARDS_DETAIL]: <ForeignCardDetail open={true} />,
  [flowPopupMapType.RUBICONE_PROMO_CAROUSEL_POPUP]: <RubiconePromoCarouselPopup open={true} />,
  [flowPopupMapType.CHARGEBACK_DOWNLOAD_POPUP]: <ChargebackDownloadPopup open={true} />,
  [flowPopupMapType.EXTEND_SESSION]: <ExtendSessionModal />,
  [flowPopupMapType.EXPIRED_SESSION]: <ExpiredSessionModal />,
  [flowPopupMapType.ECONOMIC_CONDITIONS_SELECTOR_MODAL]: <EconomicConditionsSelectorModal />,
  [flowPopupMapType.SECONDARY_USER_SHOP_LIST_MODAL]: <SecondaryUserShopListModal open={true} />,
  [flowPopupMapType.GO_TO_OLD_NPG_MODAL]: <GoToOldNpgModal />,
  [flowPopupMapType.PAGOPA_DOWNLOAD_ALL_POPUP]: <PagoPaDownloadAllPopup />,
  // [flowPopupMapType.CHECK_REFUNDABLE_PARTIALLY_TRANSACTION_MODAL]: <CheckRefundablePartiallyTransactionModal />
};

export const getPopupByID = (id) => flowPopupMap[id];

export default flowPopupMap;
